<template>
  <div class="pdf-document" id="pdf-content" v-if="displayPdfPage">
    <PDFPage
      v-for="page in pages"
      v-bind="{ scale }"
      :key="page.pageNumber"
      :page="page"
    />
  </div>
</template>

<script>
// PDFDocument renders an entire PDF inline using
// PDF.js and <canvas>. Currently does not support,
// rendering of selected pages (but could be easily
// updated to do so).
// import debug from 'debug';

// const log = debug('app:components/PDFDocument');

import PDFPage from "./PDFPage.vue";

import range from "lodash/range";

import newsService from "@/providers/newsService";
import AppConstants from '@/appConstants';
import floor from '@/helpers/floor';
// import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/web/pdf_viewer.css";

export default {
  components: {
    PDFPage,
  },
  props: {
    newsId: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    scale: {
      type: Number,
      default: 1.0,
    },
  },

  data() {
    return {
      pdf: undefined,
      pages: [],
      displayPdfPage: false
    };
  },

  computed: {
    firstPage() {
      if (!this.pages.length) return undefined;
      const [page] = this.pages;
      return page;
    },
    defaultViewportWidth() {
      return this.firstPage ? this.firstPage.getViewport({scale: 1}).width : 0;
    },
  },

  watch: {
    // scale(val) {
    //   console.log('pdfDocument scale: ', val);
    // },
    pdf: {
      handler(pdf) {
        this.pages = [];
        const promises = range(1, pdf.numPages + 1).map((number) =>
          pdf.getPage(number)
        );
        return Promise.all(promises)
          .then((pages) => {
            this.pages = pages;
          })
          .finally(() => {
            this.updateScale();
          });
      },
    },
  },

  methods: {
    updateScale() {
      const PIXEL_RATIO = window.devicePixelRatio || 1;
      const VIEWPORT_RATIO = 0.95;

      const pixelWidth = this.$el.clientWidth * PIXEL_RATIO;

      const scaleFactor = floor(pixelWidth / this.defaultViewportWidth, 2);
      const pageWidthScale = scaleFactor * VIEWPORT_RATIO;

      this.$emit("updateScaleDocumentEvent", pageWidthScale);
    },
    toggleLoading(value) {
      this.$emit('updateOverlay', value);
    },
    async fetchPDF() {
      const pdfjsLib = await import('pdfjs-dist/build/pdf');
      const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      // pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.js";

      this.toggleLoading(true);
      const params = new URLSearchParams();
      // params.append('download', false);
      newsService
        .readDocumentFile(this.newsId, params)
        .then((response) => {
          const bytes = this.CryptoJS.AES.decrypt(
            response.data,
            AppConstants.PDF_PWD
          );
          const pdfPlain = bytes.toString(this.$CryptoJS.enc.Utf8);

          // const pdfData = atob(pdfPlain);
          const pdfData = Buffer.from(pdfPlain, 'base64');
          // pdfjsLib.getDocument({data: pdfData}).promise.then(pdf => {
          

          pdfjsLib.getDocument({data: pdfData}).promise.then(pdf => {
            this.pdf = pdf;
            // this.displayPdfPage = true;
            this.toggleLoading(false);
          });

          // import(
          //   'pdfjs-dist/webpack'
          // ).then(pdfjs => pdfjs.getDocument({data: pdfData})
          // .promise.then(pdf => {
          //   this.pdf = pdf;
          //   
          // }))
        })
        .catch((error) => {
          this.toggleLoading(false);
          console.log(error);
        });
    },
  },

  mounted() {
    this.fetchPDF();
    
  },
};
</script>
<style>
/*.pdf-document {*/
/*  !*position: fixed;*!*/
/*  !*overflow: scroll;*!*/
/*  width: 100%;*/
/*  height: 90%;*/
/*}*/

.pdf-document {
  /* position: absolute; */
  overflow: auto;
  width: 100%;
  top: 150px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #999999;
  padding-top: 35px;
}
.theme-dark .pdf-document {
  background-color: #2d343b !important;
}

.scrolling-page {
  margin-bottom: 1em;
}

@media print {
  .pdf-document {
    position: static;
  }
}

#pageContainer {
  margin: auto;
  width: 80%;
  position: absolute;
}

div.page {
  display: inline-block;
}
</style>
